const STATUSES = [
  { value: 1, label: 'New Order' },
  { value: 3, label: 'shipping - awaiting customer' },
  { value: 4, label: 'shipping - received' },
  { value: 5, label: 'Processing' },
  { value: 6, label: 'Quality Control' },
  { value: 8, label: 'waiting payment' },
  { value: 9, label: 'Order Complete' },
  { value: 10, label: 'shipping - return ship kit' },
  { value: 11, label: 'payment failed' },
  { value: 12, label: 'cancelled' },
  { value: 13, label: 'removed' },
  { value: 14, label: 'Kit Sent' },
  { value: 15, label: 'Awaiting Media' },
  { value: 16, label: 'Awaiting Pick Up' },
  { value: 17, label: 'Order shipped' },
  { value: 18, label: 'Approval Required' },
  { value: 19, label: 'Order Recieved' },
  { value: 20, label: 'Local Pick Up Scheduled' },
];

const getStatusLabel = (statusCode) => {
  const status = STATUSES.find((s) => s.value === statusCode);
  return status ? status.label : `Status ${statusCode}`;
};

const getStatusCode = (statusLabel) => {
  const status = STATUSES.find((s) => s.label === statusLabel);
  return status ? status.value : null;
};

const columns = (filteredInfo = {}, statusFilters = []) => ([
  {
    title: 'Order #',
    dataIndex: 'id',
    key: 'id',
    sorter: true,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    filters: statusFilters,
    filteredValue: filteredInfo.status || null,
  },
  {
    title: 'Placed by',
    dataIndex: 'pmUser',
    key: 'pmUser',
    customFilterDropdown: true,
    filteredValue: filteredInfo.pmUser || null,
  },
  {
    title: 'Creation date',
    dataIndex: 'addedAt',
    key: 'addedAt',
    sorter: true,
  },
  {
    title: 'Total price',
    dataIndex: 'price',
    key: 'price',
    sorter: true,
  },
  {
    title: 'Request changes',
    dataIndex: 'isNewOrderChangesRequests',
    key: 'isNewOrderChangesRequests',
  },
  {
    title: 'Payment',
    dataIndex: 'payments',
    key: 'payments',
  },
  // {
  //   title: 'Actions',
  //   dataIndex: 'actions',
  //   key: 'actions',
  // },
]);

export default columns;
export { STATUSES, getStatusLabel, getStatusCode };
